import { UserAppRole } from './user_app_role';

export class User {
	constructor(
		public id: number = null,
		public first_name: string = '',
		public last_name: string = '',
		public name: string = '',
		public role: string = '',
		public last_login = '',
		public email = '',
		public is_active = true,
		public created_date = null,
		public last_modified_date = null,
		public userAppRoles: UserAppRole[] = [],
		public password: string = '',
		public userAppRole: UserAppRole = new UserAppRole(),
		public recaptcha: string = '',
		public from_user_register = 0,
		public picture: any = null
	) { }


	static fromJson(json: any) {
		if (!json) return;

		return new User(
			json.id,
			json.first_name,
			json.last_name,
			json.name,
			json.role,
			json.last_login_date,
			json.email,
			json.is_active,
			json.created_date,
			json.last_modified_date,
			json.user_to_app_to_role_by_user_id,
			json.password
		);
	}


	toJson(stringify?: boolean): any {
		var doc = {
			id: this.id,
			first_name: this.first_name,
			last_name: this.last_name,
			name: this.name,
			role: this.role,
			las_login: this.last_login,
			email: this.email,
			is_active: this.is_active,
			created_date: this.created_date,
			last_modified_date: this.last_modified_date,
			user_to_app_to_role_by_user_id: [this.userAppRole],
			password: this.password,
			recaptcha: this.recaptcha,
			from_user_register: this.from_user_register
		};

		return stringify ? JSON.stringify({ resource: [doc] }) : doc;
	}

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/srd-proinvel-pipeline/src/app/models/Users.ts